import { nanoid } from 'nanoid';
import { assignProperties, Unboxed } from '../../../../schemaUtils';
import { POLL_BINARY as QuestionType } from '../../../../types/webview.generated';
import { config } from './BinaryPoll.config';

type AnswerType = Unboxed<QuestionType['data']['answers']>;

export function generateQuestion(answers: AnswerType[], overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        text: '',
        autoCommit: false,
        requiresAnswer: true,
        goToRules: [],
        logicRules: [],
        answers: answers.length
          ? answers
          : [
              { id: nanoid(10), text: 'Нет' },
              { id: nanoid(10), text: 'Да' },
            ],
      },
      overrides,
    ),
  };
}

export function generateAnswer(overrides: Partial<AnswerType> = {}): AnswerType {
  return {
    id: nanoid(10),
    text: '',
    ...overrides,
  };
}
